<template>
  <div>

  <div class="top-bar">
    <div class="top-left">
      <div class="top-social">
      <!-- <router-link to="/kullanici/list">Hesap NO</router-link> -->
        <span> <strong>USD </strong>  {{$helper.doviz[1]}}</span>
        <span><strong>EUR </strong>{{$helper.doviz[2]}}</span>

    </div>
    </div>
    <!-- <div class="top-center">0 242 228 00 09 (Hafta içi)</div> -->
    <div class="top-right">
      <router-link to="/kullanici/list">{{hesap.kad}}</router-link>
<a href="javascript:void(0)" @click="logout">Güvenli Çıkış</a>    
</div>
  </div>

  <!-- HEADER MAIN -->
  <div class="header-main">

    <!-- LOGO + KUTULAR -->
    <div class="logo-row">

        <div class="logo-block">
          <img src="/src/static/logo.png" alt="MOBİL" class="logo-img">
          <div>
          </div>
        </div>

      <!-- PC Arama -->
      <div class="search-block-pc">
        <div class="search-inner">
        <input
        class="form-control mr-sm-2"
        type="search"
        placeholder="Ürün ara..."
        v-model="globalKeyword"
        @keyup.enter="goSearch()"
      />
      <div @click="goSearch()"  class="search-icon"><span class="icon-search"></span></div>
        </div>
      </div>

      <!-- Sağ Kutular -->
      <div class="right-cards">

        <div class="info-card info-card-bakiye">
          <div class="info-card-header">
            <span class="icon-money"></span>
            <span class="info-title">Genel Bakiye</span>
          </div>                           

          <div class="info-value">{{$helper.parabirimi($store.aktifCari.bakiye,hesap.pb)}} </div>
        </div>

        <div class="info-card cart-box">
          <div class="info-card-header">
            <!-- <span class="icon-shopping-bags"></span> -->
            <span class="info-title text-center">  Sepet ({{ cartItemCount }})
</span>
          </div>
          <div class="info-value">  {{ $helper.parabirimi(cartTotalPrice,hesap.pb) }}
</div>
        </div>
<div class="info-card info-card-parapuan">
  <div class="info-card-header">
    <span class="icon-star"></span>
    <span class="info-title">Para Puan</span>
  </div>
  <div class="info-value">0 Puan</div>
</div>
        <div class="info-card">
          <div class="info-card-header">
            <!-- <span class="icon-user"></span> -->
            <span v-if="$store.aktifCari.plasiyer == 'null null'"  class="info-title" style="font-size:17px">Satış Temsilcisi</span>
            <span v-else class="info-title" style="font-size:17px">{{$store.aktifCari.plasiyer}}</span>

          </div>
          <!-- <div class="info-value">Ad Soyad</div> -->
          <div class="info-sub">{{$store.aktifCari.ptel || '0 (5xx) xxx xx xx'}} </div>
        </div>

      </div>
    </div>

    <!-- MOBİL ARAMA -->
    <div class="search-block-mobile">
      <div class="search-inner">
        <input
        v-model="globalKeyword"
        @keyup.enter="goSearch()" placeholder="Ürün Kodu, ürün Adı">
        <div @click="goSearch()" class="search-icon"><span class="icon-search"></span></div>
      </div>
    </div>

    <!-- MOBİL ŞİRKET ADI + HAMBURGER -->
    <div class="company-line-mobile">
      <div class="company-name" style="padding-left:5px">  {{ $store.aktifCari.unvan }}
</div>
      <button id="mobileMenuBtn" class="hamburger-btn">
        <span class="icon-menu" style="color"></span>
      </button>
    </div>

  </div>

  <!-- ALT NAV (PC) -->
  <div class="bottom-nav">
    <div class="company-banner-desktop">
     {{ $helper.ilkharfBuyuk($route.name)  }}
    </div>
    <div class="bottom-nav-links">
      <router-link to="/">Anasayfa</router-link>
<router-link :to="cariRoute">
  {{ hesap.root == 1 ? 'Müşteriler' : 'Finansman' }}
</router-link>     

      <router-link to="/search">Tüm Ürünler</router-link>
      <router-link to="/stok/yeni">Yeni Ürünler</router-link>
      <router-link to="/siparis/list">Siparişler</router-link>
      <router-link to="/tahsilat/add">Ödeme</router-link>
      <router-link to="/tahsilat/liste">Tahsilatlar</router-link>
      <router-link to="/cari">Özet</router-link>

    </div>

<div class="company-banner-desktop">
  <select class="company-dd" @change="onCompanyMenu($event)">
    <option selected disabled>{{ $store.aktifCari.unvan }}</option>
    <option value="sepet">Sepetim</option>
    <option value="ekstrem">Ekstrem</option>
    <option value="odeme">Ödeme Yap</option>
    <option value="siparis">Siparişlerim</option>

    <option value="sync">Güncelleme</option>
  </select>
</div>

  </div>


  <div id="overlay" class="overlay"></div>
<aside id="cartSidebar" class="cart-sidebar">
  <div class="cart-sidebar-header">
    <span>Sepet</span>
    <button id="cartClose" class="cart-close-btn">X</button>
  </div>

  <div class="cart-sidebar-body">
    <div v-if="cartLoading" class="text-center p-3 text-muted">
      Yükleniyor...
    </div>

    <div v-else-if="!cartItems.length" class="text-center p-3 text-muted">
      Sepet boş
    </div>

<div v-else>
  <div class="cart-item" v-for="item in cartItems" :key="item.guid">
    <div class="cart-item-left">
      <div class="cart-item-image-wrapper">
            <img  class="cart-item-img" :src="item.url && item.url !== ''  ? item.url  : ('/upload/' + item.foto + '.jpg')"
            @error=" $event.target.onerror = null; $event.target.src = '/src/static/resimyok.jpg'; " >        

      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">
          {{ item.isim || 'Ürün' }}
        </div>

        <div class="cart-item-meta">
          <span class="cart-item-qty">
            Adet: <strong>{{ item.adet }}</strong>
          </span>

          <span class="cart-item-unit">
            Fiyat: <strong>{{$helper.parabirimi(($helper.kdvlimi((item.birimFiyat),hesap.kdvli,item.kdv).kdvli),hesap.pb)}}</strong>
          </span>

          <span class="cart-item-total">
            Toplam:
            <strong>{{$helper.parabirimi(($helper.kdvlimi((item.toplam),hesap.kdvli,item.kdv).kdvli),hesap.pb)}}</strong>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>

  <div class="cart-sidebar-footer">
    <router-link to="/cari/sepet">
          <button class="cart-submit-btn">Siparişi Tamamla</button>
    </router-link>
  </div>
</aside>

  <aside id="menuSidebar" class="menu-sidebar">
  <div class="menu-sidebar-header">
    <span>Kategoriler</span>
    <button id="menuClose" class="cart-close-btn">&times;</button>
  </div>
<div class="sidebar-info-block">

  <!-- PARA PUAN -->
  <div class="info-card sidebar-card">
    <div class="info-card-header">
      <span class="icon-star"></span>
      <span class="info-title">Para Puan</span>
    </div>
    <div class="info-value">0 Puan</div>
  </div>

  <!-- PLASİYER -->
  <div class="info-card sidebar-card">
    <div class="info-card-header">
      <span class="info-title">Genel Bakiye</span>
    </div>
    <div class="info-value">{{$helper.parabirimi($store.aktifCari.bakiye,hesap.pb)}}</div>
  </div> 
</div>
  <div class="menu-sidebar-body">
      <router-link to="/">Anasayfa</router-link>
<router-link :to="cariRoute">
  {{ tip == 1 ? 'Müşteriler' : 'Finansman' }}
</router-link>      

      <router-link to="/search">Tüm Ürünler</router-link>
      <router-link to="/stok/yeni">Yeni Ürünler</router-link>

      <router-link to="/siparis/list">Siparişler</router-link>
      <router-link to="/tahsilat/add">Ödeme</router-link>
      <router-link to="/stok/iade">İptal - İade</router-link>
      <router-link to="/cari">Özet</router-link>
  </div>
  </aside>
</div>
</template>
<script>
import searchStore from '@/store/index.js';
import db from '../db.js';
import { initFixedHeader } from '@/static/js/global.js';
import fiyatHelper from '../services/fiyat/yapas.js'  // yeni dosya
import syncService from '@/services/syncService';


export default {
  data() {
    return {
      hesap:this.$request.ayar(),

      tip : "",
      USD: "",
      EUR: "",
      cikis:false,
      cartItems: [],      // gösterilecek sepet
      cartLoading: false      
     
    };
  },
   
  async created() {
    this.buildCartItems(); // ilk açılışta bir kere
     this.tip = 0
    const cari = await db.caris.toArray();
    if (cari.length>1 || cari.length==0) {this.tip = 1}
  },
    mounted() {
    // Header DOM’u gerçekten hazır olduğu an
    this.$nextTick(() => {
      initFixedHeader();
    });
  },
    watch: {
    // aktifCari veya basket değiştiğinde tekrar çalışsın
    '$store.aktifCari.basket': {
      handler() {
        this.buildCartItems();
      },
      deep: true,
      immediate: true
    }
  },
    computed: {

      globalKeyword: {
      get() {
        return searchStore.keyword;
      },
      set(val) {
        searchStore.setKeyword(val);
      }
    },

    cartItemCount() {
      return this.cartItems.length;
    },

cartTotalPrice() {
  return this.cartItems.reduce((total, item) => {
    const adet = Number(item.adet || 0);
    const birim = Number(this.$helper.kdvlimi((item.fiyatDetay.iskontolu),this.hesap.kdvli,item.kdv).kdvli || 0);
    return total + (birim * adet);
  }, 0);
},

cariRoute() {
    return this.tip == 1 ? '/cari/list' : '/cari/extre';
  },
    cariLabel() {
    return this.tip === 1 ? 'Müşteriler' : 'Finansman';
  }

    },

  methods: {

 async buildCartItems() {
  const cari = this.$store.aktifCari;
  const basket = cari.basket;

  if (!basket || !Array.isArray(basket) || basket.length === 0) {
    this.cartItems = [];
    return;
  }

  this.cartLoading = true;

  try {
    const ids = basket.map(b => b.guid).filter(Boolean);
    if (!ids.length) {
      this.cartItems = [];
      return;
    }

    // stocks DB eşleşmesi
    let stocks = [];
    try {
      stocks = await db.stocks.where('id').anyOf(ids).toArray();
    } catch (e) {
      stocks = await db.stocks.toCollection()
        .filter(s => ids.includes(s.id))
        .toArray();
    }

    const map = {};
    stocks.forEach(s => { map[String(s.id)] = s; });

    const result = [];

    // cari objesini fiyatHelper’a göndermek için seçili cari
    const aktifCari = cari;

    for (const row of basket) {
      const local = map[String(row.guid)];
      if (!local) continue;

      // Extra değerler
      const extra = {
        fiyat: local.fiyat,
        kdv: local.kdv
      };

      // 🔥 fiyat hesaplama
      const fiyatDetay = await fiyatHelper.getFiyat(
        extra,
        this.$helper,
        this.hesap.kdvli,
        this.$store.aktifCari.iskontokod,0,local.doviz || 0
      );

      // net fiyat (iskontolu)
      const netFiyat = typeof fiyatDetay.iskontolu === 'number'
        ? fiyatDetay.iskontolu
        : fiyatDetay.liste;

      const adet = Number(row.adet) || 0;
      const toplamTutar = netFiyat * adet;

      result.push({
        guid: row.guid,
        adet,
        isim: local.isim,
        kod: local.kod,
        foto: local.ambalaj || null,
        kdv:local.kdv,
        // 🔥 fiyat dönenler
        birimFiyatRaw: netFiyat,
        birimFiyat: netFiyat,
        toplam:toplamTutar,
            url : local.url  || '',

        fiyatDetay // popup vs. için saklıyoruz
      });
    }

    this.cartItems = result;
  } finally {
    this.cartLoading = false;
  }
},


    logout(){
      this.$swal({
        title: "Onaylıyor musunuz?",
        text: 'Oturum kapatılacak',
        icon: "warning",
        //showCancelButton: true,
        confirmButtonText: "Evet",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
  this.$store.setLoading([true,'Oturum Sonlanıyor'])

          this.$helper.logout()

        }})
    },
    goSearch() {
      // Kelime zaten globalde, sadece sayfaya git
      this.$router.push("/search")
    },
    onCompanyMenu(e) {
    const v = e.target.value;
    e.target.selectedIndex = 0; // tekrar unvanı göster

    if (v === "sepet") this.$router.push("/cari/sepet");     // path ise değiştir
    if (v === "ekstrem") this.$router.push('/cari/extre/'); // path ise değiştir
    if (v === "odeme") this.$router.push("/tahsilat/add");     // path ise değiştir
    if (v === "siparis") this.$router.push('/siparis/list/'); // path ise değiştir    if (v === "sepet") this.$router.push("/cari/sepet");     // path ise değiştir
    if (v === "tahsilat") this.$router.push('/tahsilat/liste/');
    if (v === "sync") {
              localStorage.removeItem('last_sync');
          syncService.setcariandstok(this.$request, {
            force: false,
            lockUI: false, // ekstra garanti: kilitlenmesin
          }).catch(function (err) {
            console.error('Background sync failed:', err);
          });
    }
  }
  },
};
</script>
<style scoped>
.cart-item {
  display: flex;
  padding: 10px 0px;
  border-bottom: 1px solid #eee;
}

.cart-item-left {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}

/* Soldaki görsel alanı */
.cart-item-image-wrapper {
  width: 80px;
  min-width: 80px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-item-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Sağdaki metin alanı */
.cart-item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Ürün adı */
.cart-item-name {
  font-size: 13px;
  font-weight: 600;
  color: #222;
  margin-bottom: 4px;
  line-height: 1.3;
}

/* Adet – Birim – Toplam satırı */
.cart-item-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #555;
}

.cart-item-meta span strong {
  font-weight: 600;
}

/* Küçük ekranlarda biraz dik gelsin */
@media (max-width: 480px) {
  .cart-item {
    padding: 8px 10px;
  }

  .cart-item-meta {
    flex-direction: column;
    align-items: flex-start;
  }
}
.company-dd{
  border:none;
  border-radius:10px;
  padding:6px 10px;
  background:#fff;
  color:#0f172a;
  font-weight:600;
  font-size:15px
}


</style>


// WEBPACK FOOTER //
// src/components/headers.vue